import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./../Content-Library/AddContentModal";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const AddImportantLink = ({ isOpen, onClose, id, stepIndex, setFetchProgress }) => {
  const [title, setTitle] = useState("");
  const [importantLink, setImportantLink] = useState("");

  const sendAddContent = async () => {
    if (!title || !importantLink) {
      toastr.error("Please fill in all fields");
      throw new Error("Please fill in all fields")
    }

    const payload = {
      title,
      importantLink,
      id,
      stepIndex,
      linkIndex: null
    }
    try {
      const response = await apiServiceHandler("PATCH", "api/courses/important/link", { ...payload });
      if (response.auth) {
        toastr.success(response.message);
        setTitle("");
        setImportantLink("");
        setFetchProgress(true);
        onClose();
      } else {
        toastr.error(response.message || "Failed to invite user. Please try again.");
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      console.error(error.response);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Add Important Link</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="invite-form__field">
            <div className="text-input__label">Title</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={title}
                onChange={(e) => setTitle(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Important Link</div>
            <div className="form-input__wrapper">
              <input
                type="text"
                className="form-input__input"
                value={importantLink}
                onChange={(e) => setImportantLink(e.target.value)} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: '1rem' }}>
        <button className="send-invite__btn" onClick={sendAddContent}>
          <span className="send-invite-button__label">Add Link</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddImportantLink;
